export enum LayoutModels {
    RIGHT_SIDE_BAR = 'RIGHT_SIDE_BAR',
    FULL_WIDTH = 'FULL_WIDTH',
    LEFT_SIDE_BAR = 'LEFT_SIDE_BAR',
    NO_LAY_OUT = 'NO_LAY_OUT',
}

export enum GpsType {
    NONE = 'NONE',
    DEMOGRAPHIC = 'DEMOGRAPHIC',
    AE_DEMOGRAPHIC = 'AE_DEMOGRAPHIC',
    MARITAL_STATUS = 'MARITAL_STATUS',
    ADD_DEPENDENT = 'ADD_DEPENDENT',
    EDIT_DEPENDENT = 'EDIT_DEPENDENT',
    AE_MARITAL_STATUS = 'AE_MARITAL_STATUS',
    AE_DEPENDENT = 'AE_DENPENDENT',
    AE_RELATIONSHIP = 'AE_RELATIONSHIP',
    UPDATE_SCHEDULED_HOUR = 'UPDATE_SCHEDULED_HOUR',
    SCHEDULED_HOUR_HISTORY = ' SCHEDULED_HOUR_HISTORY',
    SCHEDULED_PAYMENT = 'SCHEDULED_PAYMENT',
    ONE_TIME_PAYMENT = 'ONE_TIME_PAYMENT',
    COMPENSATION_HISTORY = 'COMPENSATION_HISTORY',
    UNPAID_LEAVE = 'UNPAID_LEAVE',
    UPDATE_STIPE = 'UPDATE_STIPE',
    EDIT_STIPE = 'EDIT_STIPE',
    ADD_NONSTIPE = 'ADD_NONSTIPE',
    EDIT_NONSTIPE = 'EDIT_NONSTIPE',
    EMPLOYEE_LIST = 'EMPLOYEE_LIST',
    RELATIONSHIP = 'RELATIONSHIP',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    COMPENSATION = 'COMPENSATION',
    EMPLOYMENT = 'EMPLOYMENT',
    INSTITUTION_LIST = 'INSTITUTION_LIST',
    INSTITUTION_ADD_REQUEST = 'INSTITUTION_ADD_REQUEST',
    INSTITUTION_ADD_REQUEST_SUBMITTED = 'INSTITUTION_ADD_REQUEST_SUBMITTED',
    INSTITUTION_REMOVE_REQUEST = 'INSTITUTION_REMOVE_REQUEST',
    INSTITUTION_REMOVE_REQUEST_SUBMITTED = 'INSTITUTION_REMOVE_REQUEST_SUBMITTED',
    DIOCESE_LIST = 'DIOCESE_LIST',
    INSTITUTION_DETAIL = 'INSTITUTION_DETAIL',
    INSTITUTION_SURVEY = 'INSTITUTION_SURVEY',
    INSTITUTION_COMPENSATION = 'INSTITUTION_COMPENSATION',
    PLAN_SUMMARY = 'PLAN_SUMMARY',
    INSTITUTION_ADMINISTRATOR = 'INSTITUTION_ADMINISTRATOR',
    ADD_INSTITUTION_ADMINISTRATOR_REVIEW = 'ADD_INSTITUTION_ADMINISTRATOR_REVIEW',
    ADD_INSTITUTION_ADMINISTRATOR_CONFIRMATION = 'ADD_INSTITUTION_ADMINISTRATOR_CONFIRMATION',
    GROUP_LIST = 'GROUP_LIST',
    BILLING_ACCOUNT = 'BILLING_ACCOUNT',
    PARTICIPANT = 'PARTICIPANT',
    GROUP_ADMIN_LIST = 'GROUP_ADMIN_LIST',
    ADD_ADMIN = 'ADD_ADMIN',
    ADD_ADMIN_CONFIRMATION = 'ADD_ADMIN_CONFIRMATION',
    ADD_ADMIN_REVIEW = 'ADD_ADMIN_REVIEW',
    DOWNLOADS = 'DOWNLOADS',
    AE_COVERAGE = 'AE_COVERAGE',
    AE_REVIEW = 'AE_REVIEW',
    AE_CONFIRMTION = 'AE_CONFIRMTION',
    AE_HELD = 'AE_HELD',
    AE_ADMIN_HELD = 'AE_ADMIN_HELD',
    AE_INTERRUPT = 'AE_INTERRUPT',
    AE_IN_PROGRESS = 'AE_IN_PROGRESS',
    MID_YEAR_COVERAGE = 'MID_YEAR_COVERAGE',
    MID_YEAR_IN_HELD = 'MID_YEAR_IN_HELD',
    MID_YEAR_IN_PROGRESS = 'MID_YEAR_IN_PROGRESS',
    MID_YEAR_WELCOME_PAGE = 'MID_YEAR_WELCOME_PAGE',
    ALERT_NOTIFICATION = 'ALERT_NOTIFICATION',
    NEW_HIRE_DEMO = 'NEW_HIRE_DEMO',
    NEW_HIRE_STIP = 'NEW_HIRE_STIP',
    NEW_HIRE_NON_STIP = 'NEW_HIRE_NON_STIP',
    NEW_HIRE_SEARCH_INSIDE = 'NEW_HIRE_SEARCH_INSIDE',
    NEW_HIRE_SEARCH_OUTSIDE = 'NEW_HIRE_SEARCH_OUTSIDE',
    NEW_HIRE_STIP_CONFIRMATION = 'NEW_HIRE_STIP_CONFIRMATION',
    NEW_HIRE_NON_STIP_CONFIRMATION = 'NEW_HIRE_NON_STIP_CONFIRMATION',
    NEW_HIRE_RETIREMENT = 'NEW_HIRE_RETIREMENT',
    PENSION_ENROLLMENT = 'PENSION_ENROLLMENT',
    TERMINATION_FORM = 'TERMINATION_FORM',
    LOA_FORM = 'LOA_FORM',
    TERMINATION_CONFIRMATION_STIP_NONSTIP = 'TERMINATION_CONFIRMATION_STIP_NONSTIP',
    TERMINATION_CONFIRMATION_STIP = 'TERMINATION_CONFIRMATION_STIP',
    TERMINATION_CONFIRMATION_NONSTIP = 'TERMINATION_CONFIRMATION_NONSTIP',
    TERMINATION_CONFIRMATION_DEATH = 'TERMINATION_CONFIRMATION_DEATH',
    TERMINATION_CONFIRMATION_NEVER_WORKED_HERE = 'TERMINATION_CONFIRMATION_NEVER_WORKED_HERE',
    EMPLOYMENT_COMPENSATION = 'EMPLOYMENT_COMPENSATION',
    EMPLOYMENT_HISTORY = 'EMPLOYMENT_HISTORY',
    NEW_HIRE_EMPLOYMENT = 'NEW_HIRE_EMPLOYMENT',
    NEW_PARTICIPANT_WHO_WILL_ENROLL = 'NEW_PARTICIPANT_WHO_WILL_ENROLL',
    NEW_PARTICIPANT_BENEFIT_PERSON_INFO = 'NEW_PARTICIPANT_BENEFIT_PERSON_INFO',
    NEW_PARTICIPANT_RELATIONSHIP = 'NEW_PARTICIPANT_RELATIONSHIP',
    NEW_PARTICIPANT_COVERAGE = 'NEW_PARTICIPANT_COVERAGE',
    NEW_PARTICIPANT_COVERAGE_REVIEW = 'NEW_PARTICIPANT_COVERAGE_REVIEW',
    NEW_PARTICIPANT_CONFIRMATION = 'NEW_PARTICIPANT_CONFIRMATION',

	NEW_HIRE_CLERGY_TYPE = 'NEW_HIRE_CLERGY_TYPE',
	NEW_PARTICIPANT_RETIREMENT = 'NEW_PARTICIPANT_RETIREMENT',
	BENEFICIARY_LANDINGPAGE = 'BENEFICIARY_LANDINGPAGE',
	BENEFICIARY_UPDATE = 'BENEFICIARY_UPDATE',
	NEW_HIRE_RETIREMENT_ADMIN = 'NEW_HIRE_RETIREMENT_ADMIN',
	BENEFICIARY_CREATE = 'BENEFICIARY_CREATE',
	NEW_HIRE_WHO_WILL_ENROLL = 'NEW_HIRE_WHO_WILL_ENROLL',
	SCHEDULED_HOUR_WHO_WILL_ENROLL = 'SCHEDULED_HOUR_WHO_WILL_ENROLL',

	MYCPG_MIDYEAR_PERSONALINFO = 'MYCPG_MIDYEAR_PERSONALINFO',
	MYCPG_MIDYEAR_RELATIONSHIP = 'MYCPG_MIDYEAR_RELATIONSHIP',
	MYCPG_MIDYEAR_MARITAL_STATUS = 'MYCPG_MIDYEAR_MARITAL_STATUS',
	MYCPG_MIDYEAR_DEPENDENT = 'MYCPG_MIDYEAR_DEPENDENT',
	MYCPG_MIDYEAR_COVERAGE = 'MYCPG_MIDYEAR_COVERAGE',
	MYCPG_MIDYEAR_REVIEW = 'MYCPG_MIDYEAR_REVIEW',
	MYCPG_MIDYEAR_CONFIRMATION_MARRIAGE = 'MYCPG_MIDYEAR_CONFIRMATION_MARRIAGE',
	MYCPG_MIDYEAR_CONFIRMATION_LEGAL_SEPARATION = 'MYCPG_MIDYEAR_CONFIRMATION_LEGAL_SEPARATION',
	MYCPG_MIDYEAR_CONFIRMATION_DOMESTIC_PARTNERSHIP = 'MYCPG_MIDYEAR_CONFIRMATION_DOMESTIC_PARTNERSHIP',
	MYCPG_MIDYEAR_CONFIRMATION_DISSOLUTION_DOMESTIC_PARTNERSHIP = 'MYCPG_MIDYEAR_CONFIRMATION_DISSOLUTION_DOMESTIC_PARTNERSHIP',
	MYCPG_MIDYEAR_CONFIRMATION_LIFE_EVENT = 'MYCPG_MIDYEAR_CONFIRMATION_LIFE_EVENT',
	MYCPG_MIDYEAR_CONFIRMATION_ADDING_CHILDREN = 'MYCPG_MIDYEAR_CONFIRMATION_ADDING_CHILDREN',
	MYCPG_MIDYEAR_CONFIRMATION_DIVORCE = 'MYCPG_MIDYEAR_CONFIRMATION_DIVORCE',
	MYCPG_MIDYEAR_DIO_APPROVER_COVERAGE = 'MYCPG_MIDYEAR_DIO_APPROVER_COVERAGE',
	MYCPG_MIDYEAR_DIO_APPROVER_REVIEW = 'MYCPG_MIDYEAR_DIO_APPROVER_REVIEW',
	MIDYEAR_CONFIRMATION_HOURS_INCREASE = 'MIDYEAR_CONFIRMATION_HOURS_INCREASE',
	NEW_HIRE_PERSONAL_INFO = 'NEW_HIRE_PERSONAL_INFO',
	NEW_HIRE_RELATIONSHIP = 'NEW_HIRE_RELATIONSHIP',
	NEW_HIRE_MARITAL_STATUS = 'NEW_HIRE_MARITAL_STATUS',
	NEW_HIRE_DEPENDENT = 'NEW_HIRE_DEPENDENT',
	NEW_HIRE_COVERAGE_ADMIN = 'NEW_HIRE_COVERAGE_ADMIN',
	NEW_HIRE_REVIEW_ADMIN = 'NEW_HIRE_REVIEW_ADMIN',
	MEMBER_NEW_HIRE_RELATIONSHIP = 'MEMBER_NEW_HIRE_RELATIONSHIP',
	MEMBER_NEW_HIRE_PERSON_INFO = 'MEMBER_NEW_HIRE_PERSON_INFO',
	MEMBER_NEW_HIRE_MARITAL_STATUS = 'MEMBER_NEW_HIRE_MARITAL_STATUS',
	MEMBER_NEW_HIRE_EMPLOYMENT = 'MEMBER_NEW_HIRE_EMPLOYMENT',
	MEMBER_NEW_HIRE_DEPENDENT = 'MEMBER_NEW_HIRE_DEPENDENT',	
	MEMBER_NEW_HIRE_REVIEW = 'MEMBER_NEW_HIRE_REVIEW',
	NEW_HIRE_BY_DIO_CONFIRMATION = 'NEW_HIRE_BY_DIO_CONFIRMATION',
	NEW_HIRE_BY_MEMBER_CONFIRMATION = 'NEW_HIRE_BY_MEMBER_CONFIRMATION',
	NEW_ENROLLMENT_CLERGY_TYPE = 'NEW_ENROLLMENT_CLERGY_TYPE',
	NEW_HIRE_COVERAGE_DIO_APPROVER = 'NEW_HIRE_COVERAGE_DIO_APPROVER',
	NEW_HIRE_REVIEW_DIO_APPROVER = 'NEW_HIRE_REVIEW_DIO_APPROVER',
	NEW_HIRE_CONFIRMATION_DIO_APPROVER_APPROVE = 'NEW_HIRE_CONFIRMATION_DIO_APPROVER_APPROVE',
	NEW_HIRE_CONFIRMATION_DIO_APPROVER_REJECT = 'NEW_HIRE_CONFIRMATION_DIO_APPROVER_REJECT',

    MEMBER_NEW_HIRE_RETIREMENT_PLAN = 'MEMBER_NEW_HIRE_RETIREMENT_PLAN',
    INSTITUTION_ADMIN_CONFIRMATION_PENDING_APPROVAL = 'INSTITUTION_ADMIN_CONFIRMATION_PENDING_APPROVAL',
    MEMBER_NEW_HIRE_COVERAGE = 'MEMBER_NEW_HIRE_COVERAGE',
    CREATE_NEW_PARTICIPANT = 'CREATE_NEW_PARTICIPANT',

    DependentGainingHealth = 'dependent_gaining_own_benefits',
    ChangeInDomesticOrSpouse = 'spouse_or_domestic_partner_status_change',
    LossOfCoverage = 'loss_of_coverage',
    SignificantChangeInCostOrCurtailment = 'change_in_coverage_cost_or_curtailment',
    EnrollmentQualifiedHealthPlan = 'enrollment_through_health_insurance_exchange',
    DEATH_OF_CHILD = 'DEATH_OF_CHILD',
    LIFE_EVENTS_LANDING = 'LIFE_EVENTS_LANDING',

    LayDbAdoption = 'lay_db_adoption',

    LayDcAdoptionDetail = 'lay_dc_adoption_detail',
    LayDcAdoptionQuestions = 'lay_dc_questions',
    LayDcAdoptionReview = 'lay_dc_adoption_review',
    LayDcAdoptionIndemnify = 'lay_dc_adoption_indemnify',
    
    RsvpAdoptionDetail = 'rsvp_adoption_detail',
    RsvpAdoptionQuestions = 'rsvp_questions',
    RsvpAdoptionReview = 'rsvp_adoption_review',
    RsvpAdoptionIndemnify = 'rsvp_adoption_indemnify',
    
    LayDcAmendQuestions = 'lay_dc_amend_questions',
    LayDcAmendReview = 'lay_dc_amend_review',
    LayDcAmendDetail = 'lay_dc_amend_detail',
    LayDcAmendIndemnify = 'lay_dc_amend_indemnify',

    RsvpAmendDetail = 'rsvp_amend_detail',
    RsvpAmendQuestions = 'rsvp_amend_questions',
    RsvpAmendReview = 'rsvp_amend_review',
    RsvpAmendIndemnify = 'rsvp_amend_indemnify',

    DeclineMedicalDental = 'decline_medical_dental',
    JUDGEMENT_DECREE_ORDER = 'judgment_decree_or_order',

    CIC_OPT_IN_FORM = 'CIC_OPT_IN_FORM',

}